module.exports = __webpack_public_path__ + "img/layanan-alatberat.b9b94c13.webp";